import { ref } from 'vue'

/*
 * Počet bočných panelov stránky (SidePanel), ktoré práve stoja v ráme aplikácie vedľa plochy.
 * App.vue podľa neho zobrazí slot #app-side-panel — prázdny slot nezaberá miesto.
 */
export const dockedSidePanels = ref(0)
